export const ERROR_TYPES = {
    AUTH: "AUTHENTICATION_ERROR", //usuario o contraseña inválida
    CIDI: "CIDI_ERROR", //cidi caído o cualquier error de cidi
    VALIDATION: "VALIDATION_ERROR", //no pasa validacion de front
    FAILURE: "FAILURE_ERROR", //responde error el back
    NETWORK: "NETWORK_ERROR",
    SERVER: "SERVER_ERROR",
    UNKNOWN: "UNKNOWN_ERROR",
};